type XLSXModule = typeof import('xlsx');

export async function loadXlsx(): Promise<XLSXModule> {
  const mod = (await import(/* webpackChunkName: "xlsx" */ 'xlsx')) as XLSXModule | { default: XLSXModule };

  return 'default' in mod ? mod.default : mod;
}
